// extracted by mini-css-extract-plugin
export default {"outer-modal":"ReservationModal_outer-modal__0bk24","inner-modal":"ReservationModal_inner-modal__swEc3","modal-header":"ReservationModal_modal-header__5UAnu"};